import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawLeftAlignIcon from "./RawLeftAlignIcon.svg.jsx";

const LeftAlignIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawLeftAlignIcon} {...props} />;
});

export default LeftAlignIcon;
